module.exports = __webpack_public_path__ + "img/kdag.9c958b10.svg";